// import React from "react";
// import {
//   Box,
//   Container,
//   Typography,
//   Paper,
//   Avatar,
//   LinearProgress,
//   useTheme,
//   useMediaQuery,
//   styled,
// } from "@mui/material";
// import { jwtDecode } from "jwt-decode";
// import { palette, theme as colorTheme } from "../../../Convoze.theme";

// const primary = colorTheme("palette", "primary").value;
// const primaryBg = colorTheme("palette", "primaryBg").value;
// const positive = colorTheme("palette", "positive").value;
// const negative = colorTheme("palette", "negative").value;
// const neutral = colorTheme("palette", "neutral").value;



// const LeaderboardCard = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(3),
//   borderRadius: 12,
//   border: "1px solid #e0e0e0",
//   maxWidth: 500,
//   margin: "0 auto",
// }));

// const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
//   height: 8,
//   borderRadius: 4,
//   backgroundColor: "#f0f0f0",
//   "& .MuiLinearProgress-bar": {
//     borderRadius: 4,
//     backgroundColor: primary,
//   },
// }));

// const getAvatarStyle = (rank, isCurrentUser) => {
//   const palette = {
//     1: primary,
//     2: primaryBg,
//     3: primary,
//     4: primaryBg,
//     5: primary,
//   };


//   if (isCurrentUser) {
//     return {
//       bgcolor: primary,
//       color: "white",
//       fontWeight: "bold",
//     };
//   }

//   const backgroundColor = palette[rank] || palette.default;

//   return {
//     bgcolor: backgroundColor,
//     color: "white",
//     fontWeight: "bold",
//   };
// };
// const LeaderboardItem = ({ rank, name, score, isCurrentUser = false }) => {
//   const maxScore = 100;
//   const percentage = (score / maxScore) * 100;

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         mb: 2.5,
//         "&:last-child": { mb: 0 },
//       }}
//     >
//       <Avatar
//         sx={{
//           ...getAvatarStyle(rank, isCurrentUser),
//           width: 36,
//           height: 36,
//           fontSize: "1rem",
//           mr: 2,
//         }}
//       >
//         {rank}
//       </Avatar>

//       <Box sx={{ flexGrow: 1, mr: 2 }}>
//         <Typography
//           variant="body1"
//           fontWeight={isCurrentUser ? "bold" : "medium"}
//           sx={{ mb: 0.5, color: "text.primary" }}
//         >
//           {name}
//         </Typography>
//         <StyledLinearProgress
//           variant="determinate"
//           value={percentage}
//           sx={{
//             height: 8,
//             borderRadius: 5,
//             [`& .MuiLinearProgress-bar`]: {
//               backgroundColor: getAvatarStyle(rank, isCurrentUser).bgcolor,
//             },
//           }}
//         />
//       </Box>

//       <Typography
//         variant="body1"
//         fontWeight="bold"
//         sx={{
//           minWidth: 32,
//           textAlign: "right",
//           color: "text.primary",
//         }}
//       >
//         {score}
//       </Typography>
//     </Box>
//   );
// };

// function LeaderBoard({ dashboardLeaderboardData }) {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const token = localStorage.getItem("token");
//   const decodedToken = token ? jwtDecode(token) : "";

//   const currentUser = dashboardLeaderboardData?.find(
//     (agent) => agent?.agentId === decodedToken?.agentId
//   );
//   const leadersToRender =
//     dashboardLeaderboardData?.length > 5
//       ? currentUser?.rank > 5
//         ? [...dashboardLeaderboardData.slice(0, 4), currentUser]
//         : dashboardLeaderboardData.slice(0, 5)
//       : dashboardLeaderboardData;

//   const firstUser = dashboardLeaderboardData?.find((item) => item?.rank === 1);
//   const thirdUser = dashboardLeaderboardData?.find((item) => item?.rank === 3);
//   let infoText = "";
//   let pointDiff = 0;

//   if (currentUser && firstUser) {
//     const currentRank = currentUser.rank;
//     const currentScore = currentUser.averagePerformance;
//     const firstScore = firstUser.averagePerformance;
//     const thirdScore = thirdUser?.averagePerformance;

//     if (currentRank === 1) {
//       infoText = "🎉 Congratulations! You're at the top!";
//     } else if (currentRank === 2 || currentRank === 3) {
//       pointDiff = firstScore - currentScore + 1;
//       infoText = `You're just ${pointDiff} point${
//         pointDiff !== 1 ? "s" : ""
//       } away from 1st place!`;
//     } else if (currentRank <= 5) {
//       pointDiff = thirdScore - currentScore + 1;
//       infoText = `You're just ${pointDiff} point${
//         pointDiff !== 1 ? "s" : ""
//       } away from top 3!`;
//     } else {
//       const thirdUser = dashboardLeaderboardData.find(
//         (item) => item?.rank === 3
//       );
//       const thirdScore = thirdUser?.averagePerformance;
//       pointDiff = thirdScore - currentScore + 1;
//       infoText = `You're just ${pointDiff} point${
//         pointDiff !== 1 ? "s" : ""
//       } away from the 3rd position .`;
//     }
//   }
//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         flex: 1,
//         p: 2,
//         border: "1px solid #e0e0e0",
//         borderRadius: 2,
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "space-between",
//         gap: 5,
//       }}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           flexDirection: { xs: "column", md: "row" },
//           gap: 1,
//         }}
//       >
//         <Typography
//           variant="h6"
//           component="h2"
//           fontWeight="600"
//           color="text.primary"
//         >
//           Team LeaderBoard
//         </Typography>
//       </Box>

//       <Box sx={{}}>
//         {leadersToRender?.map((item) => (
//           <LeaderboardItem
//             key={item?.rank}
//             rank={item?.rank}
//             name={item?.agentFullName}
//             score={Math.round(item?.averagePerformance)}
//             isCurrentUser={item?.agentId == decodedToken?.agentId}
//           />
//         ))}
//       </Box>

//       <Box sx={{ textAlign: "center", pt: 2, borderTop: "1px solid #f0f0f0" }}>
//         <Typography variant="body2" color="text.secondary">
//           {infoText && (
//             <Box
//               sx={{
//                 textAlign: "center",
//                 pt: 2,
//                 borderTop: "1px solid #f0f0f0",
//               }}
//             >
//               <Typography
//                 variant="body2"
//                 sx={{ color: positive, fontWeight: 600 }}
//               >
//                 {infoText?.includes("Congratulations") ? (
//                   infoText
//                 ) : (
//                   <>
//                     {infoText?.split(`${pointDiff}`)[0]}
//                     <Typography
//                       component="span"
//                       color={primary}
//                       fontWeight={900}
//                       display="inline"
//                     >
//                       {Math.round(pointDiff) || 0}
//                     </Typography>
//                     {infoText?.split(`${pointDiff}`)[1]}
//                   </>
//                 )}
//               </Typography>
//               <Typography
//                 variant="body2"
//                 sx={{ color: {primary}, fontWeight: 600 }}
//               >
//                 your current rank:{" "}
//                 <Typography
//                   component="span"
//                   color={primary}
//                   fontWeight={900}
//                   display="inline"
//                 >
//                   {currentUser?.rank}
//                 </Typography>{" "}
//               </Typography>
//             </Box>
//           )}
//         </Typography>
//       </Box>
//     </Paper>
//   );
// }

// export default LeaderBoard;


import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Avatar,
  LinearProgress,
  useTheme,
  useMediaQuery,
  styled,
} from "@mui/material";
import { jwtDecode } from "jwt-decode";

const LeaderboardCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 12,
  border: "1px solid #e0e0e0",
  maxWidth: 500,
  margin: "0 auto",
}));

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 4,
  backgroundColor: "#f0f0f0",
  "& .MuiLinearProgress-bar": {
    borderRadius: 4,
    backgroundColor: "#1976d2",
  },
}));

const getAvatarStyle = (rank, isCurrentUser) => {
  const palette = {
    1: "#7635DD", // base
    2: "#8A5AE3", // slightly lighter
    3: "#9F7EE9", // light
    4: "#B5A3EF", // lighter
    5: "#CBB8F5", // very light
  };

  if (isCurrentUser) {
    return {
      bgcolor: "#feab01",
      color: "white",
      fontWeight: "bold",
    };
  }

  return {
    bgcolor: palette[rank] || "#E1DCF9",
    color: "white",
    fontWeight: "bold",
  };
};

const LeaderboardItem = ({ rank, name, score, isCurrentUser = false }) => {
  const maxScore = 100;
  const percentage = (score / maxScore) * 100;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 2.5,
        "&:last-child": { mb: 0 },
      }}
    >
      <Avatar
        sx={{
          ...getAvatarStyle(rank, isCurrentUser),
          width: 36,
          height: 36,
          fontSize: "1rem",
          mr: 2,
        }}
      >
        {rank}
      </Avatar>

      <Box sx={{ flexGrow: 1, mr: 2 }}>
        <Typography
          variant="body1"
          fontWeight={isCurrentUser ? "bold" : "medium"}
          sx={{ mb: 0.5, color: "text.primary" }}
        >
          {name}
        </Typography>
        <StyledLinearProgress
          variant="determinate"
          value={percentage}
          sx={{
            height: 8,
            borderRadius: 5,
            [`& .MuiLinearProgress-bar`]: {
              backgroundColor: getAvatarStyle(rank, isCurrentUser).bgcolor,
            },
          }}
        />
      </Box>

      <Typography
        variant="body1"
        fontWeight="bold"
        sx={{
          minWidth: 32,
          textAlign: "right",
          color: "text.primary",
        }}
      >
        {score}
      </Typography>
    </Box>
  );
};

function LeaderBoard({ dashboardLeaderboardData }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";

  const currentUser = dashboardLeaderboardData?.find(
    (agent) => agent?.agentId === decodedToken?.agentId
  );
  const leadersToRender =
    dashboardLeaderboardData?.length > 5
      ? currentUser?.rank > 5
        ? [...dashboardLeaderboardData.slice(0, 4), currentUser]
        : dashboardLeaderboardData.slice(0, 5)
      : dashboardLeaderboardData;

  const firstUser = dashboardLeaderboardData?.find((item) => item?.rank === 1);
  const thirdUser = dashboardLeaderboardData?.find((item) => item?.rank === 3);
  let infoText = "";
  let pointDiff = 0;

  if (currentUser && firstUser) {
    const currentRank = currentUser.rank;
    const currentScore = currentUser.averagePerformance;
    const firstScore = firstUser.averagePerformance;
    const thirdScore = thirdUser?.averagePerformance;

    if (currentRank === 1) {
      infoText = "🎉 Congratulations! You're at the top!";
    } else if (currentRank === 2 || currentRank === 3) {
      pointDiff = firstScore - currentScore + 1;
      infoText = `You're just ${pointDiff} point${
        pointDiff !== 1 ? "s" : ""
      } away from 1st place!`;
    } else if (currentRank <= 5) {
      pointDiff = thirdScore - currentScore + 1;
      infoText = `You're just ${pointDiff} point${
        pointDiff !== 1 ? "s" : ""
      } away from top 3!`;
    } else {
      const thirdUser = dashboardLeaderboardData.find(
        (item) => item?.rank === 3
      );
      const thirdScore = thirdUser?.averagePerformance;
      pointDiff = thirdScore - currentScore + 1;
      infoText = `You're just ${pointDiff} point${
        pointDiff !== 1 ? "s" : ""
      } away from the 3rd position .`;
    }
  }
  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        p: 2,
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 5,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: { xs: "column", md: "row" },
          gap: 1,
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          fontWeight="600"
          color="text.primary"
        >
          Team LeaderBoard
        </Typography>
      </Box>

      <Box sx={{}}>
        {leadersToRender?.map((item) => (
          <LeaderboardItem
            key={item?.rank}
            rank={item?.rank}
            name={item?.agentFullName}
            score={Math.round(item?.averagePerformance)}
            isCurrentUser={item?.agentId == decodedToken?.agentId}
          />
        ))}
      </Box>

      <Box sx={{ textAlign: "center", pt: 2, borderTop: "1px solid #f0f0f0" }}>
        <Typography variant="body2" color="text.secondary">
          {infoText && (
            <Box
              sx={{
                textAlign: "center",
                pt: 2,
                borderTop: "1px solid #f0f0f0",
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "#65C287", fontWeight: 600 }}
              >
                {infoText.includes("Congratulations") ? (
                  infoText
                ) : (
                  <>
                    {infoText.split(`${pointDiff}`)[0]}
                    <Typography
                      component="span"
                      color="#6366F1"
                      fontWeight={900}
                      display="inline"
                    >
                      {Math.round(pointDiff)||0}
                    </Typography>
                    {infoText.split(`${pointDiff}`)[1]}
                  </>
                )}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#65C287", fontWeight: 600 }}
              >
                your current rank:{" "}
                <Typography
                  component="span"
                  color="#6366F1"
                  fontWeight={900}
                  display="inline"
                >
                  {currentUser?.rank}
                </Typography>{" "}
              </Typography>
            </Box>
          )}
        </Typography>
      </Box>
    </Paper>
  );
}

export default LeaderBoard;
